<template>
    <div :class="'bizcomp-wx-bind bizcomp ' + className">
        <div class="box">
            <el-tabs v-model="activeName">
                <el-tab-pane name="first">
                    <span slot="label"><i class="wx-icon first"></i><span>已有{{ conf.sysname }}账号，请绑定</span></span>
                </el-tab-pane>
                <el-tab-pane name="second">
                    <span slot="label"><i class="wx-icon second"></i><span>没有{{ conf.sysname }}账号，请完善资料</span></span>
                </el-tab-pane>
            </el-tabs>
            <div class="input-box">
                <div class="user-img">
                    <i class="img"></i>
                    <span class="text">您好，<!-- <i class="name">李小四</i> -->欢迎来到{{ conf.sysname }}基金，完成绑定后可以微信账号一键登录哦~</span>
                </div>
                <div v-if="activeName==='first'" class="login-box">
                    <div class="login-cert-type">
                        <el-radio-group v-model="loginCertType" v-on:change="resetForm('loginForm')">
                            <el-radio v-for="item in loginType" :key="item.id" :label="item.id">
                                {{ item.name }}
                            </el-radio>
                        </el-radio-group>
                    </div>
                    <div class="login-form">
                        <el-form ref="loginForm" :rules="rules" :model="loginForm" label-width="158px" v-on:submit.native.prevent>
                            <el-form-item v-if="loginCertType === '1'" label="手机号码：" prop="phone">
                                <el-input v-model="loginForm.phone" :maxlength="11" placeholder="请输入手机号码" />
                            </el-form-item>
                            <el-form-item v-if="loginCertType === '2'" label="证件类型：" prop="certType" class="icon-select">
                                <el-select v-model="loginForm.certType" placeholder="请选择证件类型" v-on:change="checkCertNoAgain">
                                    <el-option v-for="item in certTypes" :key="item.subitem" :label="item.subitemname" :value="item.subitem" />
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="loginCertType === '2'" label="证件号码：" prop="certNo">
                                <el-input v-model="loginForm.certNo" :maxlength="20" placeholder="请输入证件号码" />
                            </el-form-item>
                            <el-form-item label="登录密码：" prop="password">
                                <el-input
                                    v-model="loginForm.password"
                                    :type="pwdType"
                                    class="reset-pwd"
                                    :maxlength="16"
                                    placeholder="请输入密码"
                                    v-on:keydown.native="detectCapsLock"
                                >
                                    <i slot="suffix" :class="iconCla" v-on:click="pwdTypeChange" />
                                </el-input>
                                <span type="text" class="reset-btn like-a" v-on:click.once="forgetPwd">忘记密码?</span>
                                <div class="capsLock-tip js-capsLock" :class="{ hide: !capsLock }">
                                    <i class="capsLockTip-triangle" />
                                    大写锁定已打开
                                </div>
                            </el-form-item>
                            <el-form-item label="验证码：" prop="verifyCode" class="verify">
                                <el-input v-model="loginForm.verifyCode" placeholder="请输入验证码" :maxlength="4">
                                </el-input>
                                <span class="prop-verify"><img id="verifyImg" :src="imgSrc" v-on:click="refresh"></span>
                            </el-form-item>
                            <el-form-item class="login-btn">
                                <el-button type="primary" class="login-n" v-on:click="login">
                                    立即绑定
                                </el-button>
                                <el-button class="quick" v-on:click.prevent="$router.push({name:'login'})">
                                    返回
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div v-else class="register-box">
                    <el-form
                        ref="ruleForm"
                        :model="ruleForm"
                        :rules="rules"
                        label-width="158px"
                        class="login-form"
                        inline-message
                        v-on:submit.native.prevent
                    >
                        <el-form-item label="手机号码：" prop="mobile">
                            <el-input v-model.trim="ruleForm.mobile" placeholder="请输入手机号码" :maxlength="11" />
                        </el-form-item>
                        <el-form-item label="手机验证码：" prop="verifyCode2" class="verifycode-row">
                            <!-- <el-input
                                v-model.trim="ruleForm.verifyCode2"
                                placeholder="请输入手机验证码"
                                :maxlength="6"
                            >
                                <el-button
                                    slot="append"
                                    class="get-verify"
                                    :disabled="time>0"
                                    v-on:click="mobileCheck"
                                >
                                    {{ btnMsg }}
                                </el-button>
                            </el-input> -->
                            <el-row>
                                <el-col :span="8">
                                    <el-input
                                        v-model.trim="ruleForm.verifyCode2"
                                        class="verifycode-style"
                                        placeholder="请输入手机验证码"
                                        :maxlength="6"
                                    >
                                    </el-input>
                                </el-col>
                                <el-col :span="4">
                                    <el-button
                                        class="get-verify"
                                        :disabled="time>0"
                                        v-on:click="mobileCheck"
                                    >
                                        {{ btnMsg }}
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item label="输入密码：" prop="pwd">
                            <el-input
                                v-model.trim="ruleForm.pwd"
                                :type="pwdType"
                                placeholder="请输入登录密码"
                                :maxlength="16"
                            >
                                <i slot="suffix" :class="iconCla" v-on:click="pwdTypeChange" />
                            </el-input>
                        </el-form-item>
                        <el-form-item label="确认密码：" prop="confirmPwd">
                            <el-input
                                v-model.trim="ruleForm.confirmPwd"
                                :type="pwdType"
                                placeholder="请再输入一次登录密码"
                                :maxlength="16"
                            >
                                <i slot="suffix" :class="iconCla" v-on:click="pwdTypeChange" />
                            </el-input>
                        </el-form-item>
                        <el-form-item class="login-btn">
                            <el-button type="primary" class="medium" v-on:click="submitForm('ruleForm',true)">
                                确定
                            </el-button>
                            <el-button class="medium" v-on:click="$router.push({name:'login'})">
                                取消
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <img-code :dialog-visible="dialogVisible" v-on:verify-in="getVerifyCode" />
        <agreement v-model="protocol" :data="agrType" v-on:all-read="agreePro"></agreement>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import imgCode from "@/components/layout/imgCode.vue";
import agreement from "@/components/form/agreement.vue";
export default {
    name: "WxBind",
    components: {
        imgCode,
        agreement
    },
    mixins: [mixin],
    data(){
        return{
            activeName: "first",
            conf:{}, // 初始化配置文件内容
            pwdType: "password", // 密码输入框类型
            loginType: [{ id: "1", name: "手机登录" }, { id: "2", name: "证件号登录" }],
            loginCertType: "1",
            imgSrc: "",
            capsLock: false,
            certTypes: [], // 证件类型
            setRefresh: null,
            iconCla: "fa fa-eye-slash", // 密码输入框图标
            loginForm: {
                phone: "",
                password: "",
                verifyCode: "",
                certType: "0",
                certNo: ""
            },
            ruleForm: {
                mobile: "",
                verifyCode2: "",
                pwd: "",
                confirmPwd: "",
                type: ""
            },
            btnMsg: "获取验证码",
            time: 0,
            dialogVisible: false,
            protocol: false,
            agrType: "register",
            rules: {
                phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }, { validator: this.$util.validateMobile, trigger: "blur" }],
                certType: [{ required: true, message: "请选择证件类型", trigger: "change" }],
                certNo: [{ required: true, message: "请输入证件号码", trigger: "blur" }, { validator: this.checkCertNo, trigger: "blur" }],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                verifyCode: [{ validator: this.$util.validateImgVerifyCode, trigger: "blur" }],
                verifyCode2: [
                    { validator: this.$util.validateVerifyCode, trigger: "blur" }
                ],
                mobile: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                pwd: [
                    { validator: this.$util.validatePwd, trigger: "blur" },
                    { validator: this.pwdCheck, trigger: "blur" }
                ],
                confirmPwd: [
                    { validator: this.$util.validatePwd, trigger: "blur" },
                    { validator: this.confirm, trigger: "blur" }
                ]
            }
        };
    },
    mounted() {
        this.certTypes = this.$cache.getDict("130007");
        this.conf = this.$util.getConfig();
        // 前端心跳-每隔3分钟刷新验证码图片，以达到登录页面用不超时的效果
        this.refresh();
    },
    beforeDestroy() {
        clearInterval(this.setRefresh);
    },
    methods: {
        /* 提交表单数据 */
        mobileCheck () {
            this.$util.mobileCheck(this, "ruleForm");
        },
        /* 获取图形验证码值 */
        getVerifyCode (val) {
            this.dialogVisible = false;
            if (val) {
                this.$util.sendSms(this, val, "ruleForm", "acct/register/sendsms");
            }
        },
        agreePro(val){
            this.protocol = false;
            if(!val)return;
            this.register();
        },
        //注册
        register(){
            let _this = this;
            const encPwd = this.$util.enc(this.ruleForm.pwd);
            _this.$util.request("acct/register/individual", {
                mobile: _this.ruleForm.mobile,
                loginpwd: encPwd,
                verifycode: _this.ruleForm.verifyCode2
            }, "POST").then(res => {
                if (res.data) {
                    _this.$store.dispatch("login", res.data[0]).then(() => {
                        this.$router.push("/home");
                    });
                }
            });
        },
        /* 提交表单数据 */
        submitForm (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (!this.locked) {
                        this.$message({
                            type: "warning",
                            message: "请先发送手机短信验证码"
                        });
                        return false;
                    }
                    if (this.locked) {
                        this.protocol = true;
                        return false;
                    }
                } else {
                    // todo
                    return false;
                }
            });
        },
        /* 表单重置 */
        resetForm(formName) {
            this.$refs[formName].resetFields();
            // 解决表单切换
            this[formName].phone = "";
            this[formName].certNo = "";
        },
        /* 密码显示或隐藏处理 */
        pwdTypeChange () {
            this.pwdType = this.pwdType === "text" ? "password" : "text";
            this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
        },
        checkCertNo(rule, value, callback) {
            this.$util.validateCertNo(rule, value, callback, this.loginForm.certType);
        },
        // 再次校验证件号码
        checkCertNoAgain() {
            this.$refs.loginForm.validateField("certNo");
        },
        detectCapsLock() {
            this.capsLock = this.$util.detectCapsLock();
        },
        /* 跳转到忘记密码页面 */
        forgetPwd() {
            this.$router.push({ name: "resetpwdway", query: { tit: "找回密码" } });
        },
        /* 刷新验证码图片 */
        refresh() {
            clearInterval(this.setRefresh);
            this.imgSrc = this.$util.imgUrl();
            this.imgRefresh();
        },
        imgRefresh(){
            this.setRefresh = setTimeout(
                (function(o) {
                    return function() {
                        o.refresh();
                    };
                })(this),
                3 * 60 * 1000
            );
        },
        bindWx (datas) {
            this.$store.dispatch("login", datas).then(() => {
                this.$router.push("/home");
            });
        },
        //已有账号，先登录后注册
        login(){
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    this.formValidSuccess();
                    return false;
                } else {
                    // todo
                    return false;
                }
            });
        },
        /* 登录成功 */
        formValidSuccess() {
            const _this = this;
            const loginPwd = this.$util.enc(this.loginForm.password);
            let t = this.loginForm.certType;
            let a = "0";
            if (this.loginCertType === "1") {
                t = "";
                a = "8";
            }
            const _data = {
                accttype: a,
                certificatetype: t,
                certificateno: this.loginForm.certNo,
                mobile: this.loginForm.phone,
                investortype: "1",
                verifycode: this.loginForm.verifyCode,
                loginpwd: loginPwd
            };
            this.$req({ url: "/common/login", data: _data, method: "POST" })
                .then(res => {
                    // 登录状态和数据更新
                    if (res.code === "0000000") {
                        _this.bindWx(res.record[0][0]);
                    } else {
                        _this.refresh();
                        _this.$message({
                            type: "warning",
                            message: res.msg
                        });
                    }
                })
                .catch(() => {
                    _this.refresh();
                });
        }
    }
};
</script>
<style lang="scss">
    @import '../../assets/css/varibles';
    .bizcomp-wx-bind{
        .box{padding: 10px 100px;}
        .el-tabs__nav{width: 100%;}
        .el-tabs__active-bar{padding: 0 10px;}
        .el-tabs__item{
            height: auto;
            width: 50%;
            padding: 0;
            text-align: center;

            >span{
                display: inline-block;
                padding: 10px 0;
                font-size: 18px;
                span{vertical-align: middle;}
            }
            &.is-active,&:hover{
                .first{
                    background-position: -36px 0;
                }
                .second{
                    background-position: -36px -35px;
                }

            }
        }
        .wx-icon{
            width: 27px;
            height: 27px;
            display: inline-block;
            background: url($wx) 0 0;
            vertical-align: middle;
            margin-right: 6px;
            &.second{
                background-position: 0 -35px;
            }
        }
        .input-box{
            width: 850px;margin: 15px auto 0;
            .user-img{
                padding: 0 15px;
                height: 48px;
                line-height: 48px;
                color: #8d939a;
                border: 1px solid #e3e9ee;
                background-color: #e7f1fb;
                .img,img{width: 32px;height: 32px;border-radius: 100%;display: inline-block;vertical-align: middle;background-color: #cccccc;margin-right: 15px;}
                .text{vertical-align: middle;.name{font-style: normal;color: #333333;padding-right: 5px;}}
            }
        }
        .reset-btn{margin-left: 10px;}
        .el-input{
            width: 50%;
            &.verifycode-style {
                width: 98%;
            }
        }
        .verify{
            .el-input{width: 43%;}
        }
        .prop-verify{
            vertical-align: middle;
            display: inline-block;
            width: 112px;height: 38px;
            margin-left: 4px;border: 1px solid #DCDFE6;
            border-radius: 4px;overflow: hidden;
            margin-top: -4px;

        }
        .login-cert-type{
            padding: 20px 0 20px 75px;
        }
        .login-form{
            .el-form-item__label{color: #999999;font-size: 16px;&:before{display: none;}padding: 0;}
        }
        .el-select{width: 100%;}
        .login-btn{
            .el-button{width: 29.5%;}
        }
        /* .get-verify span{color: $color-a;} */
        .get-verify {
            color: $color-b-o;
            min-width: 100px;
            width: 100%;
        }
        .el-button.is-disabled {
            color: $text-color3;
            background-color: transparent;
        }
        .verifycode-row {
            >.el-form-item__content>.el-form-item__error {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translateY(-50%);
            }
        }
        .register-box{margin-top: 20px;}
    }
</style>
